import tokenHttpClient from "../utils/httpClient";
import {
  post,
  postFile,
  getWithURLFileDownload,
} from "../utils/httpClient-methods";
import { API_URL, BASE_URL } from "../utils/AppApiUrl";

export const NotificationService = async (requestBody) => {
  try {
    const NotificationListResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getNotificationList}`,
      requestBody
    );
    if (NotificationListResponse.status === 200) {
      return NotificationListResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const readNotificationService = async (requestBody) => {
  try {
    const NotificationListResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.readNotification}`,
      requestBody
    );
    if (NotificationListResponse.status === 200) {
      return NotificationListResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const addBroadCastNotification = async (file, requestBody) => {
  try {
    let formData = new FormData();
    if (file) {
      formData.append("file", file);
      formData.append("notificationType", requestBody.notificationType);
      formData.append("notificationTypeId", requestBody.notificationTypeId);
      formData.append("title", requestBody.title);
      formData.append("content", requestBody.content);
      formData.append("createdOn", requestBody.createdOn);
      formData.append("createdBy", requestBody.createdBy);
      formData.append("modifiedOn", requestBody.modifiedOn);
      formData.append("modifiedBy", requestBody.modifiedBy);
      formData.append("isActive", requestBody.isActive);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("uploadDoc", requestBody.uploadDoc);
    } else {
      formData.append("notificationType", requestBody.notificationType);
      formData.append("notificationTypeId", requestBody.notificationTypeId);
      formData.append("title", requestBody.title);
      formData.append("content", requestBody.content);
      formData.append("createdOn", requestBody.createdOn);
      formData.append("createdBy", requestBody.createdBy);
      formData.append("modifiedOn", requestBody.modifiedOn);
      formData.append("modifiedBy", requestBody.modifiedBy);
      formData.append("isActive", requestBody.isActive);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("uploadDoc", requestBody.uploadDoc);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.addBroadCast}`,
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
//get count of all notification
export const getNotificationCountService = async (requestBody) => {
  try {
    const NotificationListResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getNotificationCounts}`,
      requestBody
    );
    // add condition here to check
    if (NotificationListResponse.status === 200) {
      return NotificationListResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadBroadcastService = async (id) => {
  try {
    const response = await getWithURLFileDownload(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadBroadCast}`,
      {
        broadcastId:id
      } 
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
